import { render, staticRenderFns } from "./opening-balances.vue?vue&type=template&id=a9265832&scoped=true"
import script from "./opening-balances.vue?vue&type=script&lang=js"
export * from "./opening-balances.vue?vue&type=script&lang=js"
import style0 from "./opening-balances.vue?vue&type=style&index=0&id=a9265832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9265832",
  null
  
)

export default component.exports